import React from 'react';
import ReactDOM from 'react-dom';
import HousingTypes from './HousingTypes/HousingTypes';

const root = document.getElementById('react-available-table');

if (root) {
  ReactDOM.render(<HousingTypes />, root);
}
